const userDepartments = () => {
  const departments = localStorage.getItem('departments');
  return departments.split(';');
};

export default userDepartments;
